module.exports = __webpack_public_path__ + "img/search.bfc68d92.svg";